import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function AppleIcon(props) {
    return (
        <SvgIcon {...props}>
            <g fillRule="evenodd">
                <path d="M15.03 12.894c-.026-2.875 2.288-4.274 2.393-4.34-1.31-1.964-3.34-2.233-4.054-2.254-1.705-.184-3.359 1.05-4.228 1.05-.886 0-2.224-1.031-3.665-1C3.621 6.378 1.885 7.483.933 9.2c-1.965 3.499-.5 8.641 1.382 11.47.942 1.385 2.042 2.931 3.482 2.877 1.409-.06 1.935-.925 3.636-.925 1.684 0 2.178.925 3.647.89 1.512-.025 2.464-1.391 3.373-2.79 1.088-1.587 1.525-3.151 1.542-3.231-.035-.012-2.936-1.15-2.965-4.597" />
                <path d="M12.607 3.638c.766-.973 1.29-2.295 1.144-3.638-1.109.05-2.495.778-3.293 1.73-.707.838-1.338 2.212-1.175 3.503 1.246.094 2.524-.638 3.324-1.595" />
            </g>
        </SvgIcon>
    );
}

export default AppleIcon;
